import { applyMiddleware, compose, createStore } from 'redux'
import createRootReducer from './reducers'
import thunk from 'redux-thunk';

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import SignalRChatMiddleWare from './reducers/SignalRChatMiddleWare';

import { updateChatsView } from './actions/chatActions';

const persistConfig = {
    key: '24ReadingsStorage',
    storage,
    blacklist: [ 'rtc' ]
}
const persistedReducer = persistReducer(persistConfig, createRootReducer());

export default () => {
    let store = createStore(
        persistedReducer, // root reducer with router state        
        compose(
            applyMiddleware(
                thunk,
                SignalRChatMiddleWare
            ),
        ),
    );    
    
    let persistor = persistStore(store);
    
    return { store, persistor };
}